import ReactDOM from "react-dom";
import { useState, useEffect, useRef } from "react";
import TimeOutModal from "./Utils/timeOutModal";

const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

const Portals = () => {
  const [firstLocalstorageTimeStamp, setFirstLocalstorageTimeStamp] = useState(null);
  const [openTimeoutModal, setOpenTimeoutModal] = useState(false);
  const prevCount = usePrevious(firstLocalstorageTimeStamp);

  useEffect(() => {
  
    const localStorageTimeStamp = window.localStorage.getItem("login_timeStamp");
    setFirstLocalstorageTimeStamp(localStorageTimeStamp);

    window.onstorage = (event) => {
 
      const localStorageTimeStamp = window.localStorage.getItem("login_timeStamp");
      setFirstLocalstorageTimeStamp(localStorageTimeStamp);
    };
  }, []);

  useEffect(() => {
    if (prevCount) {
      if (prevCount != firstLocalstorageTimeStamp) {
        setFirstLocalstorageTimeStamp(null);
      

        const localStorageTimeStamp = window.localStorage.getItem("login_timeStamp");
        const sessionStorageTimeStamp = window.sessionStorage.getItem("login_timeStamp");

        if (localStorageTimeStamp != sessionStorageTimeStamp) {
          if(sessionStorageTimeStamp) {
            window.close();
          } else {
            setTimeout(() => {
              setOpenTimeoutModal(true);
            }, 1000)
          
          }
      
      }
      }
    }
  }, [firstLocalstorageTimeStamp, prevCount]);

  return <>
          <TimeOutModal 
          openTimeoutModal={openTimeoutModal}
          setOpenTimeoutModal={setOpenTimeoutModal}
          />
          {ReactDOM.createPortal(
            <></>,
            document.getElementById("portal")
          )}
  </>
};

export default Portals;